/**
 * Auth selectors - single source of truth for current user from Redux.
 */
export const selectUser = (state) => state.authentication?.user ?? null;
